import {Component, OnInit} from '@angular/core';
import * as $ from "jquery";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
    ngOnInit(): void {
      $(() => {
        $('.toggle-overlay').click(() => {
          $('.nav-block').toggleClass('open');
          $('.nav-icon').toggleClass('open');
          $('body').toggleClass('open');
        });
        $('.nav-block__list a').click(() => {
          if ($('.nav-block').hasClass('open')) {

            $('.nav-block').toggleClass('open');
            $('.nav-icon').toggleClass('open');
          }
          $('body').toggleClass('open');
        });
      });
    }
  constructor() {}
}
